import axios from "axios";
import { ObjectDataSource } from "./ObjecDatatSource";

export class CompanyUserProfileObjectSource extends ObjectDataSource {

    constructor(id: number) {
        super({
            className: "companyUserProfile",
            config: {},
            id,
        });
    }

    async addEmployees(model:any){
        try {
            const resp = await axios.post(`manage/companyUserProfile/company/${this.id}/employee-invitation`,model);
            return resp.data;
        }catch (e) {
            console.error(e);
            throw e;
        }
    }

}
